import React from 'react';
import store from '../../store/Store';
import routes from '../../routes/Routes'
import actionTypes from '../../actionTypes/actionTypes';
import actions from '../../actions/Actions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Navigation from '../navigation/Navigation'

import SendOutlinedIcon from '@material-ui/icons/SendOutlined';

import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';

import IconButton from '@material-ui/core/IconButton';

import './register.scss';

type registerState = {
	email: any;
	username: any;
	password: any;
	validation: any;
	error: boolean;
	errorMessage: any;
	history: any;
}

type registerProps = {
	history: any;
}

class Register extends React.Component<registerProps, registerState> {

  constructor(props) {
  	super(props)

  	this.state = {
  		history: props.history,
  		email: '',
  		username: '',
		password: '',
		validation: '',
		error: false,
		errorMessage: ''
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			
		})
	})
  }

  register = () => {
  	const { history, username, password, validation } = this.state

  	if (password !== validation) {
  		this.setState({
  			password: '',
  			validation: '',
  			error: true,
  			errorMessage: 'Password and Validation mismatch!'
  		})

  		return
  	}

  	// FindOne -> Username -> Error -> Username already used

  	actions.registerActions.requestRegister({ user: { username: username, password: password }}).then((res) => {
  		if (res && res.errorMessage != null) {
  			this.setState({
  				password: '',
  				validation: '',
  				error: !res.success,
  				errorMessage: res.errorMessage
  			})

  			return
  		}

  		console.log(res)

  		store.dispatch({
			type: actionTypes.CHANGE_ROUTE,
			data: {
				route: routes.ROUTE_OVERVIEW
			}
		})

		store.dispatch({
			type: actionTypes.REQUEST_REGISTER,
			data: res
		})

	  	history.push(routes.ROUTE_OVERVIEW)
  	}).catch((err) => {
  		console.log(err)
  	})
  }

  onChangeUsername = (event) => {
  	console.log(event.target.value)
  	this.setState({
  		username: event.target.value
  	})
  }

  onChangePassword = (event) => {
  	console.log(event.target.value)
  	this.setState({
  		password: event.target.value
  	})
  }

  onChangeValidation = (event) => {
  	console.log(event.target.value)
  	this.setState({
  		validation: event.target.value
  	})
  }

  render() {
  	const {
  		username,
  		password,
  		validation,
  		error,
  		errorMessage
  	} = this.state

	  return (
	  	<div
	  		className="Register"
	  	>

	  		{
		  			error ? (
		  				<FormControl
		      	style={{
		      		margin: '0 12px 0 6px'
		      	}}
		      >
		  		<FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		  					{ errorMessage }
		  				</FormHelperText>
		        </FormControl>
		  			) : null
		  		} 

	  		<FormControl
		      	style={{
		      		margin: '0 12px 0 6px'
		      	}}
		      >
		          <Input
		            id="standard-adornment-weight"
		            onChange={ (event) => { this.onChangeUsername(event) }}
		            aria-describedby="standard-weight-helper-text"
		            value={ username }
		            inputProps={{
		              'aria-label': 'Username',
		            }}
		          />
		          <FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		          	Username
		          </FormHelperText>
		        </FormControl>

		      <FormControl
		      	style={{
		      		margin: '0 6px 0 12px'
		      	}}
		      >
		          <Input
		            id="standard-adornment-weight"
		            onChange={ (event) => { this.onChangePassword(event) }}
		            type="password"
		            aria-describedby="standard-weight-helper-text"
		            value={ password }
		            inputProps={{
		              'aria-label': 'Username',
		            }}
		          />
		          <FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		          	Password
		          </FormHelperText>
		        </FormControl>

		        <FormControl
		      	style={{
		      		margin: '0 6px 0 12px'
		      	}}
		      >
		          <Input
		            id="standard-adornment-weight"
		            onChange={ (event) => { this.onChangeValidation(event) }}
		            type="password"
		            aria-describedby="standard-weight-helper-text"
		            value={ validation }
		            inputProps={{
		              'aria-label': 'Username',
		            }}
		          />
		          <FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		          	Validation
		          </FormHelperText>
		        </FormControl>

	          <IconButton
	            edge={ 'end' }
	            className={ 'MenuButton' }
	            color="inherit" 
	            aria-label="menu"
	            onClick={
	            	() => this.register()
	            }
	          >
	            <SendOutlinedIcon />
	          </IconButton>

		</div>
	  );
	}
}

export default Register;